import { Icon } from '@eventbrite/eds-icon';
import { ClockChunky } from '@eventbrite/eds-iconography';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { DateType } from '../../constants/dates';
import { generateSearchUrl } from '../../pages/categoryBrowse/utils';
import './PopularTimes.scss';

export const POPULAR_TIMES_DISPLAY: Record<
    DateType | string,
    GenericLazyString
> = {
    today: gettext('Today'),
    tomorrow: gettext('Tomorrow'),
    this_weekend: gettext('This weekend'),
    this_week: gettext('This week'),
    next_week: gettext('Next week'),
    this_month: gettext('This month'),
    next_month: gettext('Next month'),
};

export const PopularTimes = (props: {
    query?: any;
    location?: any;
    activeCategoryKey?: any;
}) => {
    const { query, location, activeCategoryKey } = props;

    if (!location) {
        return null;
    }

    return (
        <div className="popular-times">
            {Object.keys(POPULAR_TIMES_DISPLAY).map((time) => {
                let currentQuery = {
                    ...query,
                    dates: time as DateType,
                };

                if (activeCategoryKey) {
                    currentQuery = {
                        ...currentQuery,
                        tags: [activeCategoryKey],
                    };
                }
                return (
                    <a
                        href={generateSearchUrl(currentQuery, location)}
                        key={time}
                        data-testid={time}
                    >
                        <div className="popular-times__card">
                            <div className="popular-times__card--icon">
                                <Icon
                                    type={<ClockChunky />}
                                    color="ui-blue"
                                    hasHalo={true}
                                />
                            </div>
                            <span className="popular-times__card--link eds-text-bl">
                                <div>{POPULAR_TIMES_DISPLAY[time]}</div>
                            </span>
                        </div>
                    </a>
                );
            })}
        </div>
    );
};
